<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path d="M19 11H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2m0-7H1a1 1 0 0 1 0-2h18a1 1 0 1 1 0 2m0 14H1a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2"/></svg>
</template>
